import React from 'react';
import {Link} from 'react-router-dom'
import { handleEventInfoData } from '../../../utils/storeConverter';
import { fireActionTriggerCustomEvent } from '../../../utils/adobe-launch';

import exitButton from '../../../assets/hero/btn-close-active (1).png'

import './ExitActivityButton.css';

const exitActivityButton = (props) => (
  <Link className="backButton" onClick={(e) => {
    handleEventInfoData({
      storeName: window.digitalData.pageInfo.page_name,
      page_name:
        window.digitalData.pageInfo.page_name + `:close ${props.activity}`,
      location_name: `Courtney tour`,
    });
    fireActionTriggerCustomEvent(
      e.target,
      window.digitalData.event
    );
  }} to={`/store/${props.storeId}`}> <img src={exitButton} alt="exit button" /> </Link>
);

export default exitActivityButton;